import { FaBitcoin, FaEthereum } from "react-icons/fa";
const walletData = [
  {
    id: 1,
    wallet: "NioWallet",
    balance: "4.434953 NIO",
    icon: <FaBitcoin />,
    color: "rgb(3, 207, 252)",
  },
  {
    id: 2,
    wallet: "Ethereum Wallet",
    balance: "0.000298 ETH",
    icon: <FaEthereum />,
    color: "rgb(4, 18, 20)",
  },
];

export default walletData;
